"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPrefix = exports.Page = void 0;
exports.Page = {
    OfferPage: "/offer",
    OffersPage: "/offers",
    LeaderboardPage: "/leaderboard",
    WaitingPurchasePage: "/waiting-purchase",
    PaymentSuccessPage: "/payment-success",
    PaymentFailedPage: "/payment-failed",
    TicketPage: "/ticket",
    LineCallbackPage: "/auth/line/callback"
};
// API path prefix (from environment variable)
var getApiPrefix = function () {
    var env = window._env_;
    return ((env === null || env === void 0 ? void 0 : env.API_PREFIX) || "/api");
};
exports.ApiPrefix = getApiPrefix();
